import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../../Context/AuthContext";
import { httpClient } from "../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";

const _ModalDetailRCSAgent = (props) => {
  const { visible, data, onClose, title = "" } = props;
  const auth = useAuth();
  const { token } = auth.getSessionData();

  const { data: agent, isPending } = useQuery({
    queryKey: ["detailRCSAgent", data?.uuid_agent],
    queryFn: async () => {
      const response = await httpClient(
        "GET",
        `${ApiEndpoint}administration/rcsagentdetail/${data.uuid_agent}`,
        {},
        token,
      );
      return response.data;
    },
    enabled: visible && !!data?.uuid_agent,
    refetchOnWindowFocus: false,
  });
  const _onClose = () => {
    if (onClose) onClose();
  };

  const maskToken = (value) => {
    if (!value) return "---";

    const visible = value.slice(-4);
    const masked = "*".repeat(Math.max(value.length - 4, 0));

    return visible + masked;
  };

  return (
    <Modal show={visible} onHide={_onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      {visible && (
        <Modal.Body>
          {isPending ? (
            <div className="text-center">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              <div className="grid grid-cols-2 gap-y-3 gap-x-6">
                <div className="flex flex-col">
                  <span className="text-md font-semibold text-gray-500">
                    Partner
                  </span>
                  <span className="text-md">{agent?.vc_partner ?? "---"}</span>
                </div>

                <div className="flex flex-col">
                  <span className="text-md font-semibold text-gray-500">
                    Nombre
                  </span>
                  <span className="text-md">{agent?.vc_name ?? "---"}</span>
                </div>

                <div className="flex flex-col">
                  <span className="text-md font-semibold text-gray-500">
                    Agente
                  </span>
                  <span className="text-md">{agent?.vc_agentid ?? "---"}</span>
                </div>

                <div className="flex flex-col">
                  <span className="text-md font-semibold text-gray-500">
                    Proveedor
                  </span>
                  <span className="text-md">{agent?.vc_provider ?? "---"}</span>
                </div>

                <div className="flex flex-col">
                  <span className="text-md font-semibold text-gray-500">
                    Carrier
                  </span>

                  <span className="text-md">
                    {agent?.vc_carrier ? agent?.vc_carrier : "---"}
                  </span>
                </div>
              </div>
              <hr className="my-4" />

              <div className="grid grid-cols-2 gap-y-3 gap-x-6">
                <div className="flex flex-col">
                  <span className="text-md font-semibold text-gray-500">
                    Single Key
                  </span>
                  <span className="font-mono truncate overflow-hidden">
                    {maskToken(agent?.vc_singlekey)}
                  </span>
                </div>

                <div className="flex flex-col">
                  <span className="text-md font-semibold text-gray-500">
                    Basic Key
                  </span>
                  <span className="font-mono truncate overflow-hidden">
                    {maskToken(agent?.vc_basickey)}
                  </span>
                </div>

                <div className="flex flex-col">
                  <span className="text-md font-semibold text-gray-500">
                    API Key
                  </span>
                  <span className="font-mono truncate overflow-hidden">
                    {maskToken(agent?.vc_apikey)}
                  </span>
                </div>
              </div>
              <hr className="my-4" />
              <div className="grid grid-cols-2 gap-y-3 gap-x-6">
                <div className="flex flex-col">
                  <span className="text-md font-semibold text-gray-500">
                    Token
                  </span>
                  <span className="font-mono truncate overflow-hidden">
                    {maskToken(agent?.vc_token)}
                  </span>
                </div>
              </div>
            </>
          )}
        </Modal.Body>
      )}
      <Modal.Footer>
        <button className="btn btn-primary" onClick={_onClose}>
          Aceptar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

_ModalDetailRCSAgent.propTypes = {
  visible: PropTypes.bool,
  data: PropTypes.object,
  onClose: PropTypes.func,
  title: PropTypes.string,
};
export default _ModalDetailRCSAgent;
